import React from 'react';

export default function PostHeader({title, photo}) {
    return(
        <section className="bg-lines py-6 px-7">
            <div className="container p-0">

                <div className="row no-gutters">

                    <div className="col-md-6 px-2" data-animation="fade-in-bottom 1s .1s">
                        <h2 className="bold uppercase">{title}</h2>
                    </div>

                    <div className="col-md-6" data-animation="fade-in-bottom 1s .2s">
                        <figure className="figure">
                            <img src={photo} className="figure-img img-fluid" alt={title}/>
                        </figure>
                    </div>

                </div>

            </div>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/visitors/components/post/PostHeader.js